module.exports = __webpack_public_path__ + "img/4-01-05-info.fe499dba.svg";